/* @flow */

import Clickable from "./Clickable";

export type { ClickableAction } from "./Clickable";
export type { Props as ClickableProps } from "./Clickable";
export default Clickable;
